function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  fillOpacity: 0.01
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 14H6V13H11V5H3V10H2V5C2.00028 4.73487 2.10572 4.48068 2.2932 4.2932C2.48068 4.10572 2.73487 4.00028 3 4H11C11.2651 4.00028 11.5193 4.10572 11.7068 4.2932C11.8943 4.48068 11.9997 4.73487 12 5V13C11.9997 13.2651 11.8943 13.5193 11.7068 13.7068C11.5193 13.8943 11.2651 13.9997 11 14Z",
  fill: "#0F62FE"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 11H13V10H14V2H6V3H5V2C5.00028 1.73487 5.10572 1.48068 5.2932 1.2932C5.48068 1.10572 5.73487 1.00028 6 1H14C14.2651 1.00028 14.5193 1.10572 14.7068 1.2932C14.8943 1.48068 14.9997 1.73487 15 2V10C14.9997 10.2651 14.8943 10.5193 14.7068 10.7068C14.5193 10.8943 14.2651 10.9997 14 11Z",
  fill: "#0F62FE"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 7V8H7.293L1.5 13.793L2.207 14.5L8 8.707V11H9V7H5Z",
  fill: "#0F62FE"
});
const SvgOpenLink = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open-link.e32a69c1.svg";
export { ForwardRef as ReactComponent };